import { OrderResponseDto } from "./OrderResponseDto";
import { OrderResponseModel } from "./OrderResponseModel";

export const transformOrderResponseDtoToModel = (
  dto: OrderResponseDto
): OrderResponseModel => dto;
